// extracted by mini-css-extract-plugin
export default {"TutorialResponse-Tooltip":"TutorialResponse-TooltipGxDmY1UwJ1ke"};